import { BFILogoHorizontal } from '@assets/images/svg';
import MemoizedIcon from '@components/MemoizedIcon';
import Notification from '@components/Notification';
import useFeatureFlags from '@hooks/useFeatureFlags';
import useMediaQuery from '@hooks/useMediaQuery';
import menuIcon from '@iconify/icons-heroicons-outline/menu';
import { MAX_WIDTH_SM } from '@src/constants';
import { useSidebarContext } from '@src/context/SidebarContext';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import UserProfileSection from './UserProfileSection';

type Props = {
  openSidebar: () => void;
};

const Header: FC<Props> = ({ openSidebar }) => {
  const isMobile = useMediaQuery(MAX_WIDTH_SM);
  const { features } = useFeatureFlags();

  const { hasNotification } = useSidebarContext();

  return (
    <div className="bg-white sm:rounded-none h-[67px] sm:h-[77px] fixed w-full z-50 shadow-[0_1px_4px_rgba(0,0,0,0.08)]">
      <nav className="h-full">
        <div className="mx-auto px-5 sm:px-5 lg:px-6 h-full">
          <div className="flex items-center justify-between h-full w-full relative">
            <button
              data-testid="btn-open-sidebar"
              onClick={() => {
                openSidebar();
              }}
              className="relative"
            >
              <MemoizedIcon icon={menuIcon} className="h-6 w-6" />
              {hasNotification && (
                <div className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full" />
              )}
            </button>
            <Link
              to="/"
              className="flex items-center absolute left-1/2 -translate-x-1/2"
            >
              <img
                src={BFILogoHorizontal}
                alt="BFILogoHorizontal"
                width={123}
                height={35}
              />
            </Link>

            <div
              data-testid="header-right-container"
              className="flex items-center gap-x-10"
            >
              {features.showNotification() && <Notification />}
              {!isMobile && <UserProfileSection />}
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
